var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTitleEssentiaExperience(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 225.382,
    height: 97.418,
    viewBox: "0 0 225.382 97.418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_21",
    "data-name": "Ret\\xE2ngulo 21",
    width: 225.382,
    height: 67.418,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c79e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0d0a2",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1825",
    "data-name": "Grupo 1825",
    transform: "translate(-432 -2786.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22",
    "data-name": "Grupo 22",
    transform: "translate(432 2816.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_706",
    "data-name": "Caminho 706",
    d: "M.984,240.13v20.9H15.018v-2.757H4.116v-6.516H14.8V249H4.116v-6.109h10.9V240.13Z",
    transform: "translate(-0.795 -193.983)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_707",
    "data-name": "Caminho 707",
    d: "M119.6,252.5l-6.265,8.521h-3.79l8.02-10.714-7.55-10.181h3.791l5.8,8.02,5.764-8.02h3.791l-7.487,10.15,7.957,10.745h-3.759Z",
    transform: "translate(-88.494 -193.983)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21",
    "data-name": "Grupo 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20",
    "data-name": "Grupo 20",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_708",
    "data-name": "Caminho 708",
    d: "M253.48,240.13h8.8c4.292,0,6.673,2.945,6.673,6.422a6.25,6.25,0,0,1-6.673,6.422h-5.67v8.051H253.48Zm8.4,2.757h-5.263v7.331h5.263a3.67,3.67,0,1,0,0-7.331",
    transform: "translate(-204.767 -193.983)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_709",
    "data-name": "Caminho 709",
    d: "M376.875,240.13h14.034v2.757h-10.9V249H390.69v2.757H380.008v6.516h10.9v2.757H376.875Z",
    transform: "translate(-304.448 -193.983)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_710",
    "data-name": "Caminho 710",
    d: "M503.408,252.974h-3.916v8.051h-3.133v-20.9h8.8c3.978,0,6.7,2.569,6.7,6.422a5.829,5.829,0,0,1-5.2,6.109l5.357,8.364h-3.634Zm1.347-10.087h-5.263v7.331h5.263a3.671,3.671,0,1,0,0-7.331",
    transform: "translate(-400.97 -193.983)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_19",
    "data-name": "Ret\\xE2ngulo 19",
    width: 3.133,
    height: 20.895,
    transform: "translate(119.761 46.147)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_711",
    "data-name": "Caminho 711",
    d: "M689.848,240.13h14.034v2.757h-10.9V249h10.682v2.757H692.98v6.516h10.9v2.757H689.848Z",
    transform: "translate(-557.275 -193.983)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_712",
    "data-name": "Caminho 712",
    d: "M812.465,244.986v16.039h-3.133v-20.9h3.227l11.372,15.663V240.13h3.133v20.9h-3.039Z",
    transform: "translate(-653.798 -193.983)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_713",
    "data-name": "Caminho 713",
    d: "M947.235,249.146a10.463,10.463,0,0,1,10.714-10.808,9.448,9.448,0,0,1,8.3,4.417l-2.663,1.41a6.623,6.623,0,0,0-5.639-3.039c-4.229,0-7.487,3.32-7.487,8.02,0,4.668,3.258,8.02,7.487,8.02a6.623,6.623,0,0,0,5.639-3.039l2.663,1.41a9.488,9.488,0,0,1-8.3,4.417,10.463,10.463,0,0,1-10.714-10.808",
    transform: "translate(-765.198 -192.535)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_714",
    "data-name": "Caminho 714",
    d: "M1088.561,240.13h14.034v2.757h-10.9V249h10.682v2.757h-10.682v6.516h10.9v2.757h-14.034Z",
    transform: "translate(-879.364 -193.983)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_715",
    "data-name": "Caminho 715",
    d: "M0,2.607H22.9V7.768H5.863v8.669H22.549V21.6H5.863v9.27H22.9v5.161H0Z",
    transform: "translate(0 -2.106)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_716",
    "data-name": "Caminho 716",
    d: "M142.49,24.7a14.417,14.417,0,0,0,10.573,4.61c4.81,0,6.714-2.355,6.714-4.56,0-3.007-3.558-3.908-7.617-4.961-5.462-1.353-11.876-2.956-11.876-10.022,0-5.512,4.861-9.771,12.177-9.771,5.211,0,9.42,1.654,12.527,4.66l-3.357,4.36A13.587,13.587,0,0,0,151.96,5.21c-3.457,0-5.662,1.654-5.662,4.159,0,2.606,3.408,3.457,7.366,4.46,5.512,1.4,12.076,3.107,12.076,10.373,0,5.562-3.908,10.322-12.928,10.322-6.163,0-10.623-2.154-13.579-5.311Z",
    transform: "translate(-112.476 0.001)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_717",
    "data-name": "Caminho 717",
    d: "M297.366,24.7a14.417,14.417,0,0,0,10.573,4.61c4.81,0,6.714-2.355,6.714-4.56,0-3.007-3.558-3.908-7.617-4.961-5.462-1.353-11.876-2.956-11.876-10.022,0-5.512,4.861-9.771,12.177-9.771,5.211,0,9.42,1.654,12.527,4.66l-3.357,4.36a13.587,13.587,0,0,0-9.671-3.808c-3.457,0-5.662,1.654-5.662,4.159,0,2.606,3.408,3.457,7.366,4.46,5.512,1.4,12.076,3.107,12.076,10.373,0,5.562-3.909,10.322-12.928,10.322-6.163,0-10.623-2.154-13.579-5.311Z",
    transform: "translate(-237.588 0.001)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_718",
    "data-name": "Caminho 718",
    d: "M460.2,2.607h22.9V7.768H466.06v8.669h16.686V21.6H466.06v9.27H483.1v5.161H460.2Z",
    transform: "translate(-371.758 -2.106)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_719",
    "data-name": "Caminho 719",
    d: "M616.5,11.677V36.03h-5.863V2.607h6.013l17.087,23.7V2.607H639.6V36.03h-5.662Z",
    transform: "translate(-493.29 -2.106)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_720",
    "data-name": "Caminho 720",
    d: "M797.279,7.769H787.157V2.607h26.107V7.769H803.142V36.03h-5.863Z",
    transform: "translate(-635.884 -2.106)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_20",
    "data-name": "Ret\\xE2ngulo 20",
    width: 5.863,
    height: 33.422,
    transform: "translate(182.34 0.501)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_721",
    "data-name": "Caminho 721",
    d: "M1022.792,29.616h-15.834l-2.455,6.414h-6.414l13.129-33.422h7.316l13.128,33.422h-6.414Zm-14.181-5.161h12.527l-6.264-16.887Z",
    transform: "translate(-806.279 -2.106)",
    fill: "#161615"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_38",
    "data-name": "Ret\\xE2ngulo 38",
    width: 225,
    height: 5,
    transform: "translate(432 2786.7)",
    opacity: 0.717,
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleEssentiaExperience);
export default __webpack_public_path__ + "static/media/title-essentia-experience.fd28bc271dc4595c9cf3feec7b393caa.svg";
export { ForwardRef as ReactComponent };